const { __, _x, _n, _nx } = wp.i18n;

var SubscriptionsModal = ( function() {
  function C() { return constructor.apply( this, arguments ); };
  var p = C.prototype;

  function constructor() {
		this.modal = document.getElementById( 'content-page-subscriptions-modal' );
		if ( ! this.modal ) {
			return;
		}
		this.submitButton = this.modal.querySelector( 'button[data-loading-text]' );
		this.form = this.modal.querySelector( 'form' );
		this.form.addEventListener(
			'submit', this.handleSubmit.bind( this ) );
  };

	// Handles submits of the options form
  p.handleSubmit = function( event ) {
		event.preventDefault();
		this.submitButtonOldContent = this.submitButton.innerHTML;
		this.submitButton.setAttribute( 'disabled', true );
		this.submitButton.innerHTML = this.submitButton.getAttribute( 'data-loading-text' );
		this.saveOptions();
	};

	// Save options
	p.saveOptions = function() {
		var self = this;
		var jqxhr = jQuery.ajax( {
			url: wpApiSettings.root + 'iportal/v1/content_page_subscriptions/'
				+ this.form.getAttribute( 'data-page-id' ),
			method: 'PUT',
			data: jQuery( this.form ).serialize(),
			beforeSend: function( xhr ) {
				xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
			},
		} ).done( function( response ) {
			self.submitButton.removeAttribute( 'disabled' );
			self.submitButton.innerHTML = self.submitButtonOldContent;
			location.reload();
			jQuery( self.modal ).modal( 'hide' );
		} ).fail( function() {
			var errorMessage = document.createElement('div');
			errorMessage.setAttribute( 'class', 'alert alert-danger mb-0' );
			errorMessage.innerHTML = __( 'Could not save settings, please try again later', 'iportal-theme' );
			self.submitButton.remove();
			var footer = self.modal.querySelector( '.modal-footer' );
			footer.insertBefore( errorMessage, footer.firstChild );
		} );
	};

  return C;
})();

export default SubscriptionsModal;